export const MICROAPP_NAME = "ai-red-teaming";

export const EMPTY_OBJECT = {};

export const ROOT_PATH = "/insights/ai-security";
export const RED_TEAMING_SUBPATH = "/red-teaming";
export const MODEL_SCANNING_SUBPATH = "/model-scanning";
export const API_SUBPATH = "/api/runtime-security";
export const NETWORK_SUBPATH = "/command-center";
